var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52342 0.799316H3.9483C3.68507 0.799316 3.47168 1.01271 3.47168 1.27594V1.58842C3.47168 1.85165 3.68507 2.06504 3.9483 2.06504H9.52342C9.78665 2.06504 10 1.85165 10 1.58842V1.27594C10 1.01271 9.78665 0.799316 9.52342 0.799316Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52342 4.43311H3.9483C3.68507 4.43311 3.47168 4.6465 3.47168 4.90973V5.2222C3.47168 5.48544 3.68507 5.69883 3.9483 5.69883H9.52342C9.78665 5.69883 10 5.48544 10 5.2222V4.90973C10 4.6465 9.78665 4.43311 9.52342 4.43311Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52342 7.88812H3.9483C3.68507 7.88812 3.47168 8.10151 3.47168 8.36475V8.67722C3.47168 8.94045 3.68507 9.15384 3.9483 9.15384H9.52342C9.78665 9.15384 10 8.94045 10 8.67722V8.36475C10 8.10151 9.78665 7.88812 9.52342 7.88812Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2677 0.333374H0.92991C0.416335 0.333374 0 0.749709 0 1.26328V1.60107C0 2.11465 0.416335 2.53098 0.92991 2.53098H1.2677C1.78128 2.53098 2.19761 2.11465 2.19761 1.60107V1.26328C2.19761 0.749709 1.78128 0.333374 1.2677 0.333374Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30701 3.96716H0.969217C0.455642 3.96716 0.0393066 4.3835 0.0393066 4.89707V5.23486C0.0393066 5.74844 0.455642 6.16477 0.969217 6.16477H1.30701C1.82058 6.16477 2.23692 5.74844 2.23692 5.23486V4.89707C2.23692 4.3835 1.82058 3.96716 1.30701 3.96716Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30701 7.42218H0.969217C0.455642 7.42218 0.0393066 7.83852 0.0393066 8.35209V8.68988C0.0393066 9.20346 0.455642 9.61979 0.969217 9.61979H1.30701C1.82058 9.61979 2.23692 9.20346 2.23692 8.68988V8.35209C2.23692 7.83852 1.82058 7.42218 1.30701 7.42218Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/ListIcon.108c0b58f8bf11270fdd45191e06e80b.svg";
export { ForwardRef as ReactComponent };